<template>
  <WelcomeHeader />

  <!-- ══ HERO ══ -->
  <section class="cl-hero">
    <div class="cl-hero-tint"></div>
    <div class="cl-container">
      <div class="cl-hero-inner">
        <span class="cl-eyebrow">কোর্স সমূহ</span>
        <h1 class="cl-hero-title">আপনার স্বপ্নের চাকরির <span>সম্পূর্ণ প্রস্তুতি</span></h1>
        <p class="cl-hero-sub">
          বিসিএস, ব্যাংক, প্রাইমারি ও শিক্ষক নিবন্ধন সহ সকল চাকরির জন্য ক্যাডার-এনালাইজড সিলেবাস,
          ফিক্সড রুটিন ও নিয়মিত পরীক্ষা — সবকিছু এক জায়গায়।
        </p>
        <div class="cl-hero-stats">
          <div class="cl-hstat">
            <b>{{ toBengali(courseList.length) }}+</b><span>প্রিমিয়াম কোর্স</span>
          </div>
          <div class="cl-hstat">
            <b>{{ toBengali(guidelines.length) }}+</b><span>বিষয় গাইডলাইন</span>
          </div>
          <div class="cl-hstat">
            <b>ফ্রি</b><span>সাপ্তাহিক মডেল টেস্ট</span>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ══ COURSES ══ -->
  <section class="cl-section">
    <div class="cl-container">
      <div class="cl-head">
        <span class="cl-eyebrow">আমাদের কোর্স সমূহ</span>
        <h2 class="cl-h2">প্রস্তুতি শুরু করুন আজই</h2>
        <p class="cl-note">প্রতিটি কোর্স সাজানো হয়েছে টপিকভিত্তিক বিশ্লেষণ ও ফিক্সড রুটিনে।</p>
      </div>
      <div class="cl-grid">
        <article v-for="(course, index) in courseList" :key="index"
                 class="ccard" @click="goToCourseDetails(course)">
          <div class="ccard-media">
            <img :src="course.image" :alt="course.title" loading="lazy" />
          </div>
          <div class="ccard-body">
            <div class="ccard-meta">
              <span class="ccard-cat" :class="courseMeta(course).cls">{{ courseMeta(course).category }}</span>
              <span v-if="courseMeta(course).free" class="ccard-free">ফ্রি</span>
            </div>
            <h3 class="ccard-title">{{ course.title }}</h3>
            <p class="ccard-desc">{{ course.short_description }}</p>
            <span class="ccard-link">
              বিস্তারিত পড়ুন
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </article>
      </div>
    </div>
  </section>

  <!-- ══ GUIDELINES ══ -->
  <section class="cl-section cl-section-alt">
    <div class="cl-container">
      <div class="cl-head cl-head-row">
        <div>
          <span class="cl-eyebrow">ফ্রি রিসোর্স</span>
          <h2 class="cl-h2">বিষয়ভিত্তিক গাইডলাইন</h2>
          <p class="cl-note">বিসিএস ৩৫–৫০ পর্যন্ত টপিকভিত্তিক প্রশ্ন বিশ্লেষণ, হিটম্যাপ ও প্রস্তুতি কৌশল।</p>
        </div>
        <div class="cl-head-stats">
          <div class="cl-hstat"><b>১৬</b><span>বিসিএস বিশ্লেষণ</span></div>
          <div class="cl-hstat"><b>{{ toBengali(guidelines.length) }}</b><span>বিষয় গাইডলাইন</span></div>
        </div>
      </div>
      <div class="cl-grid">
        <article v-for="(guide, index) in guidelines" :key="index"
                 class="ccard" @click="goToGuideline(guide)">
          <div class="ccard-media">
            <img :src="guide.image" :alt="guide.title" loading="lazy" />
            <span class="ccard-mark">{{ guide.marks }}</span>
          </div>
          <div class="ccard-body">
            <div class="ccard-meta">
              <span class="ccard-tag" v-for="t in guide.tags.slice(0, 3)" :key="t">{{ t }}</span>
            </div>
            <h3 class="ccard-title">{{ guide.title }}</h3>
            <p class="ccard-desc">{{ guide.desc }}</p>
            <span class="ccard-link">
              গাইডলাইন দেখুন
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none">
                <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
          </div>
        </article>
      </div>
    </div>
  </section>

  <WelcomeFooter />
</template>
<script>
import { defineComponent } from "vue";
import router from "@/router";
import {URLs} from "@/static";
import {courseList} from "@/config/utils";
import {guidelines} from "@/components/WelcomePages/guidelinesData";
import WelcomeFooter from "@/components/WelcomePages/WelcomeFooter.vue";
import WelcomeHeader from "@/components/WelcomePages/WelcomeHeader.vue";
export default defineComponent({
  components: {
    WelcomeFooter,
    WelcomeHeader
  },
  setup() {
    const goToCourseDetails = (course) => {
      router.push({
        name: URLs.ROUTE_COURSE_DETAILS_NAME,
        params: { title: course.url_text }
      });
    };

    const toBengali = (n) => {
      const bn = ['০','১','২','৩','৪','৫','৬','৭','৮','৯'];
      return String(n).split('').map(c => bn[+c] ?? c).join('');
    };

    // Derive a clean category chip + "free" flag from the course content
    const courseMeta = (course) => {
      const t = course.title || '';
      const blob = `${t} ${course.short_description || ''}`;
      let category = 'কোর্স', cls = 'cat-default';
      if (t.includes('মডেল টেস্ট')) { category = 'মডেল টেস্ট'; cls = 'cat-test'; }
      else if (t.includes('প্রশ্ন ব্যাংক')) { category = 'জব সল্যুশন'; cls = 'cat-solution'; }
      else if (t.includes('সল্যুশন') || t.includes('সমাধান')) { category = 'জব সল্যুশন'; cls = 'cat-solution'; }
      else if (t.includes('ব্যাংক')) { category = 'ব্যাংক'; cls = 'cat-bank'; }
      else if (t.includes('প্রাইমারি')) { category = 'প্রাইমারি'; cls = 'cat-primary'; }
      else if (t.includes('বিসিএস')) { category = 'বিসিএস'; cls = 'cat-bcs'; }
      const free = /ফ্রি|বিনামূল্যে/.test(blob);
      return { category, cls, free };
    };

    const goToGuideline = (guide) => {
      router.push({ name: guide.route });
    };

    return {
      courseList,
      goToCourseDetails,
      courseMeta,
      guidelines,
      goToGuideline,
      toBengali,
    };
  },
});
</script>

<style scoped>
/* ════════════════ MINIMAL · LIGHT ════════════════
   white surfaces · hairline borders · one blue accent · type-led */

.cl-container { width: 100%; max-width: 1200px; margin: 0 auto; padding: 0 24px; }
@media (max-width: 575px) { .cl-container { padding: 0 18px; } }

/* shared type */
.cl-eyebrow {
  display: block;
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 0.72rem; font-weight: 700; letter-spacing: 0.14em;
  text-transform: uppercase; color: #0095FF; margin-bottom: 12px;
  text-align: left;
}
.cl-h2 {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: clamp(1.5rem, 3vw, 2.05rem); font-weight: 700; line-height: 1.28;
  color: #0f1222; margin: 0; letter-spacing: -0.01em;
}
.cl-note { font-size: 0.95rem; color: #6b7585; margin: 12px 0 0; line-height: 1.6; }

/* ── Hero ── */
.cl-hero {
  position: relative; overflow: hidden;
  background: #ffffff;
  border-bottom: 1px solid #eef1f5;
  padding: 64px 0 60px;
}
.cl-hero-tint {
  position: absolute; top: -180px; right: -140px;
  width: 520px; height: 520px; border-radius: 50%;
  background: radial-gradient(circle, rgba(0,149,255,0.10) 0%, rgba(0,149,255,0) 68%);
  pointer-events: none;
}
.cl-hero-inner { position: relative; max-width: 720px; text-align: left; }
.cl-hero-inner .cl-eyebrow,
.cl-hero-inner .cl-hero-title,
.cl-hero-inner .cl-hero-sub { text-align: left; }
.cl-hero-title {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: clamp(2rem, 4.4vw, 3.05rem); font-weight: 700; line-height: 1.2;
  color: #0f1222; margin: 0 0 18px; letter-spacing: -0.015em;
}
.cl-hero-title span { color: #0095FF; }
.cl-hero-sub {
  font-size: 1.05rem; line-height: 1.8; color: #5a6473;
  margin: 0 0 32px; max-width: 620px;
}
.cl-hero-stats { display: flex; flex-wrap: wrap; gap: 0; }
.cl-hstat {
  display: flex; flex-direction: column;
  padding: 2px 26px; position: relative;
}
.cl-hstat:first-child { padding-left: 0; }
.cl-hstat + .cl-hstat::before {
  content: ""; position: absolute; left: 0; top: 4px; bottom: 4px;
  width: 1px; background: #e6eaf0;
}
.cl-hstat b {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 1.65rem; font-weight: 700; color: #0f1222; line-height: 1;
}
.cl-hstat span { font-size: 0.8rem; color: #8a93a3; margin-top: 7px; }

/* ── Sections ── */
.cl-section { background: #ffffff; padding: 60px 0; }
.cl-section-alt { background: #fafbfc; border-top: 1px solid #eef1f5; }
.cl-head { margin-bottom: 36px; text-align: left; }
.cl-head .cl-h2, .cl-head .cl-note, .cl-head .cl-eyebrow { text-align: left; }
.cl-head-row {
  display: flex; align-items: flex-end; justify-content: space-between;
  flex-wrap: wrap; gap: 24px;
}
.cl-head-stats { display: flex; gap: 0; }

/* ── Grid ── */
.cl-grid {
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 26px;
  align-items: stretch;
}
@media (max-width: 991px) { .cl-grid { grid-template-columns: repeat(2, 1fr); gap: 22px; } }
@media (max-width: 575px)  { .cl-grid { grid-template-columns: 1fr; } }

/* ── Card ── */
.ccard {
  display: flex; flex-direction: column;
  background: #ffffff;
  border: 1px solid #eaeef3;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
}
.ccard:hover {
  transform: translateY(-4px);
  border-color: #d4e6fb;
  box-shadow: 0 18px 40px -22px rgba(15,30,80,0.22);
}

.ccard-media {
  position: relative;
  aspect-ratio: 1080 / 566;        /* exact banner ratio — never crops */
  background: #f1f5f9;
  border-bottom: 1px solid #eef1f5;
  overflow: hidden;
}
.ccard-media img {
  width: 100%; height: 100%; object-fit: cover; display: block;
  transition: transform .5s ease;
}
.ccard:hover .ccard-media img { transform: scale(1.035); }
.ccard-media::after {            /* subtle inner ring to settle busy banners */
  content: ""; position: absolute; inset: 0;
  box-shadow: inset 0 0 0 1px rgba(15,23,42,0.04);
  pointer-events: none;
}
.ccard-mark {
  position: absolute; top: 12px; right: 12px;
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 0.72rem; font-weight: 700; color: #0066CC;
  background: rgba(255,255,255,0.94); border: 1px solid #e4ebf3;
  padding: 4px 11px; border-radius: 999px;
  backdrop-filter: blur(4px);
}

.ccard-body {
  display: flex; flex-direction: column; flex: 1 1 auto;
  padding: 18px 20px 20px;
}
.ccard-meta { display: flex; flex-wrap: wrap; gap: 7px; margin-bottom: 12px; }
.ccard-cat {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 0.72rem; font-weight: 600;
  padding: 3px 11px; border-radius: 999px;
  color: #0066CC; background: #eef6ff; border: 1px solid #d8e9fc;
}
.ccard-cat.cat-bank { color: #0f766e; background: #ecf6f4; border-color: #cfe9e3; }
.ccard-cat.cat-primary { color: #b05415; background: #fdf2e9; border-color: #f4dcc6; }
.ccard-cat.cat-test { color: #7c3aa8; background: #f5eefb; border-color: #e7d6f5; }
.ccard-cat.cat-solution { color: #334155; background: #f1f5f9; border-color: #e2e8f0; }
.ccard-free {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 0.72rem; font-weight: 700;
  padding: 3px 11px; border-radius: 999px;
  color: #0b7a43; background: #eafaf1; border: 1px solid #c7eed8;
}
.ccard-tag {
  font-size: 0.7rem; font-weight: 500; color: #5a6473;
  background: #f4f6f9; border: 1px solid #e8edf2;
  padding: 3px 9px; border-radius: 6px;
}

.ccard-title {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 1.1rem; font-weight: 600; line-height: 1.45;
  color: #0f1222; margin: 0 0 8px; text-align: left;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.ccard-desc {
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 0.875rem; font-weight: 400; line-height: 1.7;
  color: #6b7585; margin: 0 0 18px; text-align: left;
  display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
}
.ccard-link {
  margin-top: auto;
  display: inline-flex; align-items: center; gap: 7px;
  font-family: 'Noto Sans Bengali', sans-serif;
  font-size: 0.9rem; font-weight: 600; color: #0066CC;
  transition: gap .2s ease, color .2s ease;
}
.ccard:hover .ccard-link { gap: 11px; color: #0095FF; }
</style>